<script>
import { LogCompanyShow } from '@/events'

export default {
  template: '<template></template>',
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    LogCompanyShow(this.companyId)
  },
}
</script>

<style lang="scss">
@use '../../AboutUs/AboutUs';
@use '../../AboutUs/AboutSection';
@use '../../ContactBlock/ContactBlock';
@use '../../CompanyText/CompanyText';
@use '../../CompanyDealers/CompanyDealers';
@use '../../IconifiedContentCard/IconifiedContentCard';
@use '../../AccordionPanel/AccordionPanel';
@use '../../AccordionTable/AccordionTable';
@use '../../AccordionContent/AccordionContent';
@use '../../CompanyLogo/CompanyLogo';
@use '../../Quote/Quote';
@use './CompanyDetail';
@use '../../../styles/CompanyCard';
@use '../../FacebookPanel/FacebookPanel';
</style>
